<template>
  <div class="box">
    <arrorImg bg="white"></arrorImg>
    <navBar title="领取优惠券" color="#ffffff"></navBar>
    <div class="content-box">
      <span class="content-title">{{
        isGetConpon == 0 ? "恭喜您领取限时优惠券！" : "优惠券已领完"
      }}</span>
      <span class="content-tips" v-if="isGetConpon == 0"
        >已存入“我的-优惠券”</span
      >
      <div class="list-item" v-for="(item, index) in List" :key="index">
        <div
          class="conpon-item"
          :class="isGetConpon == 1 ? 'conpon-default' : ''"
        >
          <div>
            <span class="conpon-yuan">￥</span
            ><span class="conpon-text">{{ item.reduceMoney }}</span>
            <div class="counpon-center">
              <span class="conpon-count">满{{ item.fullMoney }}可用</span>
              <span class="conpon-time">有效期至{{ item.expireTime }}</span>
            </div>
          </div>
          <span
            class="conpon-btn"
            v-if="isGetConpon == 0"
            @click="routeCharge(item)"
            >去使用</span
          >
          <span class="conpon-btndefault" v-else>已领完</span>
        </div>
        <img   src="../../../static/new_getcoupon.png"
          v-if="isGetConpon == 0" alt="">
      </div>
      <div class="view-tip">
        <span style="text-align: center">优惠券说明</span>
        <span
          >1.优惠券可用于充值书币，会员时直接减免，不与其他优惠活动同享</span
        >
        <span>2.优惠券存在有效期，请在有效期内使用；</span>
        <!-- style="color:#F09B28;" -->
        <span>3.若你对本券有疑问，请<span @click="goFeedback"  style="color:#FCCA9D;" >点我反馈</span></span>
      </div>
    </div>
  </div>
</template>
<script>
import arrorImg from "../../components/arrow-img.vue";
import navBar from "../components/navbar.vue";
export default {
  components: {
    arrorImg,
    navBar,
  },
  data() {
    return {
      List: [],
      isGetConpon: 0,
      couponIds: "",
      isEntranceData: "",
      pageType: "",
    };
  },
  mounted() {
  },
  beforeRouteEnter(to, from, next) {
    if (from.name == "tabbar"||from.path=='/') {
      to.meta.isBack = false;
      to.meta.keepAlive = true;
    } else {
      // 当从上个页面chooseCoupons返回当前页面时，不刷新当前页面
      to.meta.isBack = true;
      to.meta.keepAlive = true;
    }
    next();
  },
   activated() {
    this.pageType=this.$route.query.pageType
    console.log(this.$route.query.pageType);
    if(!this.$route.meta.isBack){
       console.log(this.$route.query.pageType);
    if (this.$route.query.isEntranceData) {
      this.isEntranceData = this.$route.query.isEntranceData;
    }
    this.couponIds = this.$route.query.couponIds;
    var openid = this.$base.getStorage("openid");
    var isWxAuthorized = this.$base.getStorage("isWxAuthorized");
      var city = this.$base.getStorage("city");
    if (!openid) {
      //静默登录手动登录
      // #ifdef H5
      // #endif
    } else if (isWxAuthorized==0&&city==1 && openid && !this.$store.state.user.isSNS) {
      this.$base.setStorage("isSNS", true);
      this.$store.state.user.isSNS = true;
      this.$commonApi.snsapiUserinfo();
      this.usersReceiveCoupons();
    } else {
      this.usersReceiveCoupons();
    }
    }
    this.$commonApi.share();
  },
  methods: {
    usersReceiveCoupons() {
      var params = {
        isRechargePage: 1,
        receiveEntrance: 0, //弹窗入口
        entranceIds: this.couponIds,
      };
      this.$api.usersReceiveCoupons(params).then((res) => {
        if (res.status == 1) {
          this.isGetConpon = res.data.isFinishState;
          res.data.couponReturnDTO.forEach((item) => {
            if (item.expireTime) {
              item.expireTime = this.$base.getTimeMiute(item.expireTime);
            }
          });
          this.List = res.data.couponReturnDTO;
          this.insertPageAccessData();
        }
      });
    },
    insertPageAccessData() {
      var prevPage = "";
      if (this.pageType === "bookCurrency") {
        prevPage = "书币";
      }else if (this.pageType === "bookCharge") {
        prevPage = "充值中心";
      } else if (this.pageType === "bookCity") {
        prevPage = "书城";
      } 
      var params = {
        pageName: "获取优惠券",
        pageRemark:"上级页面：" + prevPage,
        isEntranceData: this.isEntranceData,
      };
      this.$api.insertPageAccessData(params).then((res) => {});
    },
    routeCharge(item) {
      this.$router.push({
        path: "/pages/bookCharge/index",
        query: {
          couponId: item.id,
          pageType: "bookCharge",
        },
      });
    },
    goFeedback(){
       this.$router.push({
        path: "/pages/bookFeedback/index",
        query: {
          pageType: "getCoupons",
        },
      });
    }
  },
};
</script>

<style scoped>
.box {
  min-height: 100%;
  padding: 18px;
  background-image: linear-gradient(-180deg, #ff5a53 0%, #de3b34 100%);
}
.content-box {
  background-image: url("https://quickappimg.oss-cn-shanghai.aliyuncs.com/iconImg/group_conpon.png");
  background-repeat: no-repeat;
  flex-direction: column;
  padding: 12px 0px;
  background-size: contain;
  margin-top: calc(44px + env(safe-area-inset-top));
}

.content-title {
  font-size: 20px;
  color: #ffffff;
  display: block;
  text-align: center;
  margin-top: 16px;
  margin-bottom: 9px;
}

.content-tips {
  font-size: 12px;
  color: #ffffff;
  margin-bottom: 6px;
  text-align: center;
  display: block;
}

.view-tip > span {
  font-size: 12px;
  color: #ffffff;
  display: block;
  margin-bottom: 6px;
  line-height: 17px;
}

.list-item {
  background-image: url(../../../static/coupon_bg.png);
  position: relative;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 24px;
  box-sizing: border-box;
  margin-bottom: 16px;
  border-radius: 12px;
}

.list-item > img {
  width: 40px;
  height: 38px;
  position: absolute;
  left: 0px;
  top: 0px;
}

.conpon-item {
  display: flex;
  justify-content: space-between;
}

.conpon-item > div {
  display: flex;
}

.counpon-center > span {
  display: block;
  margin-left: 7px;
}

.conpon-yuan {
  font-size: 14px;
  color: #de3b34;
  line-height: 40px;
}

.conpon-text {
  font-size: 28px;
  color: #de3b34;
  font-weight: bold;
  width: 51px;
}

.conpon-count {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
}

.conpon-time {
  font-size: 11px;
  color: #aaaaaa;
  margin-top: 3px;
}

.conpon-btn {
  background-color: #de3b34;
  border-radius: 12px;
  width: 58px;
  height: 24px;
  font-size: 12px;
  text-align: center;
  line-height: 24px;
  color: #ffffff;
  margin-top: 10px;
}

.conpon-default > div > .conpon-yuan,
.conpon-default > div > .conpon-text,
.conpon-default > div > div > .conpon-count {
  color: #aaaaaa;
}

.conpon-btndefault {
  font-size: 12px;
  color: #aaaaaa;
}
</style>



// WEBPACK FOOTER //
// src/view/getCoupons/index.vue